import React from 'react';
import styled from 'styled-components/macro';
import { isMobile } from 'react-device-detect';
import { device } from '../../style/Sizes';
import { Button } from '../UI/Button/Button';

const TextContainer = styled.div`
  margin-top: 32px;
  text-align: center;
  width: 100%;

  @media ${device.maxHeightS} {
    margin-top: ${() => (isMobile ? '16px' : '')};
  }

  @media ${device.heightM} {
    margin-top: 66px;
  }
`;

const HiText = styled.p`
  color: #223742;
  font-size: 32px;
  font-family: Lato;
  font-weight: 700;

  @media ${device.heightM} {
    font-size: 42px;
  }
`;

const IamText = styled.p`
  margin-top: 15px;
  color: #223742;
  font-size: 20px;
  font-family: miller-display, serif;
  font-style: italic;
  font-weight: 400;
  line-height: 29px;

  @media ${device.heightM} {
    font-size: 26px;
    line-height: 38px;
  }
`;

const GetInTouchContainer = styled.div`
  margin-top: 32px;

  @media (max-height: 540px) {
    margin-top: ${() => (isMobile ? '8px' : '')};
  }
`;

const HomeWelcome = () => {
  return (
    <TextContainer>
      <HiText>Hi! I’m Peter,</HiText>
      <IamText>
        a UX | UI Designer
        <br />
        with a passion for designing
        <br /> delightful user experiences.
        <br />
        And I love to code.
      </IamText>
      <GetInTouchContainer>
        <Button href="mailto:info@peterfrommann.de">Get In Touch</Button>
      </GetInTouchContainer>
    </TextContainer>
  );
};

export default HomeWelcome;
